import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import hisService from "services/admin/masters/hisService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import {getMatrixId} from "utils/matriceHelpers";
import {
  MAPPING_SELECT_ERROR_TEMPLATE,
  MSG_MAPPING_DELETE_WARNING,
  MSG_MAPPING_RESTORE_WARNING
} from "constants/admin/masters/his";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";

function ManageHisDrive() {
   const Id = getMatrixId(window.location.pathname);
    
  const [breadcrumbs, setBreamcrumbs] = useState([
    { title: "HIS Masters Mapping", url: "/admin/master/his/" },
    { title: "Manage Mapping" },
  ]);
  const serviceObj = new hisService();

  // form fields
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [selectedCombineKeys, setSelectedCombineKeys] = useState([]);
  const [driveList, setDriveList] = useState([{}]);
  const [selectedDriveDetails, setDriveDetails] = useState(null);
  const [driveTableData, setDriveTableData] = useState([]);
  const [vsanCache, setVsanCache] = useState("");
  const [vsanCapacity, setVsanCapacity] = useState("");
  const [firmware, setFirmware] = useState("");
  const [driver, setDriver] = useState("");

  const [isEditForm, setEditForm] = useState(false);
  const [editableItem, setEditableItem] = useState(null);
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [combineKeyError, setCombineKeyError] = useState('');
  const [driveError, setDriveError] = useState('');
  const [warningType, setWarningType] = useState(null);

  useEffect(() => {
    getDriveData();
  }, []);
  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateDriveForm();
    }
  }, [selectedCombineKeys, selectedDriveDetails]);
  // call api to get drive mapping page data
  const getDriveData = () => {
    serviceObj
      .getAllInitialData(Id)
      .then((response) => {

        let combineKeyList = response?.his_combine_keys;
        let list = combineKeyList.map((item) => {
          return {
            id: item.id,
            value: item.combine_key,
            label: item.combine_key,
          };
        });
        let driveList = response?.drive_drop_list.map((item) => {
          return {
            id: item.id,
            value: item.name,
            label: item.name,
            isDisabled: item.disabled,
          };
        });
        let tableData = response?.existing_mapping_list;
        setDriveTableData(tableData);
        setCombineKeyList(list);
        setDriveList(driveList);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };
  // multi select dropdown function
  const selectMultipleValue = (selectedValues) => {
    setSelectedCombineKeys(selectedValues);
  };
  const resetForm = () => {
    setSelectedCombineKeys([]);
    setDriveDetails(null);
    setEditForm(false);
    setEditableItem(null);
    setVsanCache("");
    setVsanCapacity("");
    setFirmware("");
    setDriver("");
    setEditForm("");
    setItemToBeDeleted(null);
    setIsFormTouched(false);
    setDriveError("");
    setCombineKeyError("");
    setWarningType("")
  };
  // function to add new drive mapping
  const addDriveMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    // form fields data check validation
    const isFormValid = validateDriveForm();

    // call POST api if form is valid
    if (isFormValid) {
      //form fields data
      let payload = {
        drive_id: selectedDriveDetails.id,
        drive_vsan_cache: vsanCache,
        drive_firmware: firmware,
        drive_driver: driver,
        his_combine_keys: selectedCombineKeys.map((key) => key.id),
        drive_vsan_capacity: vsanCapacity,
      };
      // api call
      serviceObj.createDriveMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getDriveData();
        resetForm();
      });
    }
  };

  // validate fields and set or reset error message
  const validateDriveForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

    if (!selectedDriveDetails?.value) {
      setDriveError(getErrorMessageFor("Drive"));
      isFormValid = false;
    } else {
      setDriveError("");
    }


    return isFormValid;
  };
  // create error message based on field name 
  const getErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };
  // get edit item details from api call and store in state
  const editForm = (data) => {
    setEditForm(true);
    // call get api to get edit drive details.
    serviceObj.getDriveKeyDetails(data.id).then((response) => {
      // storing editable item details in local state for final edit api
      setEditableItem(response);
      let item = response?.record_details;
      let combineKeys = response?.his_combine_keys.map((item) => {
        return {
          id: item.id,
          value: item.combine_key,
          label: item.combine_key,
          isDisabled: true
        }

      })
      let driveList = {
        id: item.drive_id,
        value: item.drive,
        label: item.drive,
      };
      setDriveDetails(driveList)
      setSelectedCombineKeys(combineKeys);
      setVsanCache(item.drive_vsan_cache)
      setVsanCapacity(item.drive_vsan_capacity)
      setFirmware(item.drive_firmware)
      setDriver(item.drive_driver)
    })
  }

  // update drive
  const updateDriveMapping = (e) => {
    e.preventDefault();
    let data = {
      his_combine_keys: selectedCombineKeys.map((key) => key.id),
      drive_id: editableItem.record_details.drive_id,
      drive_vsan_cache: vsanCache,
      drive_firmware: firmware,
      drive_driver: driver,
      drive_vsan_capacity: vsanCapacity,
    }
    let ID = editableItem.record_details.id;
    serviceObj.updateDriveMapping(ID, data).then((response) => {
      toast.success(MSG_RECORD_UPDATE);
      getDriveData();
      resetForm();
    }).catch(error => toast.error(ERROR_MESSAGE_UNKNOWN))
  };

  // show delete warning confirmation popup
  const showWarning = (rowData) => {
    let type = rowData.is_deleted ? "restore" : "delete";
    setWarningType(type);
    let message = rowData.is_deleted ? MSG_MAPPING_RESTORE_WARNING : MSG_MAPPING_DELETE_WARNING;
    setConfirmMessage(message + rowData.drive + " ?");
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
  };
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  };
  // delete or restore selected drive
  const deleteDriveFunction = () => {
    let ID = itemToBeDeleted.id;
    // deleteDriveMapping is used for both delete and restore 
    serviceObj.deleteDriveMapping(ID)
      .then((response) => {
        let toastMessage = warningType === "restore" ? MSG_RECORD_UNDO_DELETE : MSG_RECORD_DELETE;
        toast.success(toastMessage);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getDriveData();
        setItemToBeDeleted(null);
      }).catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getDriveData();
        setItemToBeDeleted(null);
      })
  }

  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />

      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteDriveFunction}
          handleSubmit={deleteDriveFunction}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}

      {/* main form section */}
      <div className="form-group d-flex">
        <div className="col-sm-4">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                <label htmlFor={""} className="mr-sm-2 mt-2">
                  <b>HIS Combine Key</b>
                </label>
                {/* add multi select dropdown */}
                <Select
                  isMulti
                  name="Combine Key"
                  options={combineKeyList}
                  classNamePrefix="select"
                  onChange={(e) => selectMultipleValue(e)}
                  value={selectedCombineKeys}
                  isSearchable={true}
                  isClearable={true}
                />
                {
                  combineKeyError
                  &&
                  <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                }

                <label htmlFor={"Drive"} className="mr-sm-2 mt-2">
                  <b>Drive </b>
                </label>
                <div className="form-group">
                  <Select
                    name="Drive"
                    options={driveList}
                    classNamePrefix="Select"
                    onChange={(e) => setDriveDetails(e)}
                    value={selectedDriveDetails}
                    isDisabled={isEditForm}
                  />
                  {
                    driveError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{driveError}</div>
                  }
                </div>
                <label htmlFor={"Drive vSAN Cache"} className="mr-sm-2 mt-2">
                  <b>Drive vSAN Cache </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="vsanCache"
                    value={vsanCache}
                    onChange={(e) => setVsanCache(e.target.value)}
                    disabled={selectedDriveDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"Drive vSAN Capacity"} className="mr-sm-2 mt-2">
                  <b>Drive vSAN Capacity </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="vsanCapacity"
                    value={vsanCapacity}
                    onChange={(e) => setVsanCapacity(e.target.value)}
                    disabled={selectedDriveDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"Drive Firmware"} className="mr-sm-2 mt-2">
                  <b>Drive Firmware </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="firmware"
                    value={firmware}
                    onChange={(e) => setFirmware(e.target.value)}
                    disabled={selectedDriveDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"Drive Driver"} className="mr-sm-2 mt-2">
                  <b>Drive Driver </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="driver"
                    value={driver}
                    onChange={(e) => setDriver(e.target.value)}
                    disabled={selectedDriveDetails === null}
                    placeholder="Enter value"
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <button
                type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"
              >
                <i className="fa fa-refresh"></i> Reset
              </button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={isEditForm ? updateDriveMapping : addDriveMapping}
              >
                {isEditForm ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-8">
          <MaterialTable
            title="Drive Mappings"
            columns={[
              { title: "Combine Key", field: "his_combine_key" },
              { title: "Drive", field: "drive" },
              { title: "Drive vSAN Cache", field: "drive_vsan_cache" },
              { title: "Drive vSAN Capacity", field: "drive_vsan_capacity" },
              { title: "Drive Firmware", field: "drive_firmware" },
              { title: "Drive Driver", field: "drive_driver" },
            ]}
            data={driveTableData && driveTableData}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400,
            }}
            localization={{
              header: {
                actions: "Actions",
              },

            }}
            actions={[
              (rowData) => ({
                icon: "edit",
                tooltip: !rowData.is_deleted && "Edit Record",
                onClick: (e, data) => {
                  // call edit function
                  editForm(data);
                },
                hidden: !rowData?.id || rowData.is_deleted// display action only if any valid item is present
              }),
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                onClick: (e, data) => {
                  showWarning(data);
                },
                hidden: !rowData?.id // display action only if any valid item is present
              }),
            ]}
          />
        </div>
      </div>
      {/* form end */}
    </div>
  );
}

export default ManageHisDrive;
